<template>
	<div class="resource-card-container" v-if="payload">
    <a :href="`/${$filters.convertResourceType(payload['resource-type'])}/${payload['slug']}`">
      <div class="resource-card">

        <div v-intersection.once="intersection_handler" class="resource-card__header" :style="computedBGImage">
          <button :class="`pill ${pillColor}`" v-if="payload['resource-type']">{{ payload['resource-type'] }}</button>
        </div>

        <div class="resource-card__body">
          <h4 class="resource-card__body-title">{{ payload['title'] }}</h4>

          <div class="resource-card__body-group">
            <div class="resource-card__body-group-date" v-if="payload['publish-date']">
              {{ $filters.ukDate(payload['publish-date']) }}
            </div>
          </div>

          <p class="resource-card__body-text">{{ payload['summary'] }}</p>
        </div>

        <div :class="`resource-card__footer ${footer_color}`">
          <template v-if="payload['author-name'] !== undefined && payload['author-name'] !== ''">
						<div class="resource-card__footer-img-wrapper">
							<img class="resource-card__footer-img" :src="$filters.analyseImage(payload['author-image'],'logosm','logoxl')" alt="Author" width="40" height="40" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
						</div>
						<div class="resource-card__footer-group">
							<p class="resource-card__footer-title">Author</p>
							<p class="resource-card__footer-name">
								{{ payload['author-name'] }}
							</p>
						</div>
					</template>
        </div>

      </div>
    </a>
	</div>
</template>

<script>
	export default {
		props: {
			payload: {
				type: Object
			},
			footer_color: {
				type: String,
				default: 'bg-grey'
			}
		},

		data() {
			return {
				visible: false
			}
		},

    mounted() {

    },

		methods:{
			intersection_handler(entries, observer, isIntersecting, ratio) {
				//console.log("handle",entries, observer, isIntersecting, ratio);
				if (isIntersecting) {
					this.visible = true;
				}

			}
		},
    
		computed: {
			computedBGImage() {
				if (this.visible) {
					return `background-image: url(${this.$filters.analyseImage(this.payload['cover-image'],'herosearchxs','herosearchsm')});`;
				}
				return '';
			},
      pillColor() {
        let result = this.payload['resource-type'] ? this.payload['resource-type'].replace(/\s+/g, '-').toLowerCase() : 'default';
        return result;
      },
		}
	}
</script>
